// services/userService.ts

import config from "../config";


const BASE_URL = config.backendUrl;

export interface UserProfile {
  id: string;
  name: string;
  email: string;
  profilePictureUrl?: string;
};

export interface UploadProfilePicturePayload {
  file: File;
};

export interface UpdateUserPayload {
  name: string;
  email: string;
  profilePictureUrl?: string;
};

/** GET /user/:id — fetch user profile */
export async function fetchUserProfile(userId: number): Promise<UserProfile> {
  const response = await fetch(`${BASE_URL}/user/${userId}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch user profile: ${response.statusText}`);
  }
  const data = await response.json();
  const newProfile: UserProfile = {
    id: data.id,
    name: data.name,
    email: data.email,
    profilePictureUrl: data.profilePictureUrl
  }
  return newProfile;
};

/** PATCH /user/:id - update user profile */
export async function updateUserProfile(
  userId: number,
  payload: UpdateUserPayload
): Promise<void> {
  const response = await fetch(`${BASE_URL}/user/${userId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`Failed to update user profile: ${response.statusText}`);
  }
};

export async function uploadProfilePicture (
  userId: number,
  file: File
): Promise<string> {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${BASE_URL}/user/${userId}/profile_picture`, {
    method: 'POST',
    body: formData
  });

  if (!response.ok) {
    throw new Error(`Failed to upload profile picture: ${response.statusText}`);
  }
  const data = await response.json();
  return data.url;
};